/**
* Face Concerns JS
* -----------------------------------------------------------------------------
*
* All the JS for the Face Concerns component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'face-concerns',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth > 1023 ) {
        $( '.face-concerns .concern-content' ).each( function( key, val ) {
          const concern = $( '.face-concerns .concern[data-concern="' + $( this ).attr( 'data-concern' ) + '"]' )[0];
          const height = $( this ).outerHeight();

          function toggleClasses() {
            $( val ).toggleClass( 'is-active' );
            $( concern ).toggleClass( 'is-active' );
          }

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: '-100% 50%',
              end: '150% 50%',
              scrub: 0,
              onEnter: toggleClasses,
              onLeaveBack: toggleClasses,
              onLeave: toggleClasses,
              onEnterBack: toggleClasses,
              // markers: true,
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'face-concerns', COMPONENT );
} )( app );
